import React from "react";
import ChatWidget from "./ChatWidget";

// Permite override por env var (REACT_APP_CS_SERVER_URL) si en algún
// ambiente quieres apuntar a otro backend. Si no, va al server live.
export const CS_SERVER_URL =
  process.env.REACT_APP_CS_SERVER_URL ||
  "https://customer-service-production-d8c9.up.railway.app";

const CustomerServiceModal = () => {
  return (
    <ChatWidget
      serverUrl={CS_SERVER_URL}
      companyName="Physiology"
      welcomeText="¡Hola! ¿En qué podemos ayudarte?"
      primaryColor="#2f3237"
      position="right"
      accountUrl="/account"
      ordersUrl="/account"
      shopConcernUrl="/shop?concern=Manchas"
      distributorUrl="/store-locator"
    />
  );
};

export default CustomerServiceModal;
